module.exports = __webpack_public_path__ + "static/media/malaysia05.9d19be8e.jpg";